import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getEmojiList } from '@/api/live';
import LikeHeart from "../like";
export default {
  name: "BaseInfo",
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    emojiOpen: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    client: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      width: 200,
      //初始宽度
      height: 300,
      //初始高度
      heartList: [],
      //初始数组
      heartCount: 0,
      //累加计数初始值
      danmuOpen: true
    };
  },
  computed: {},
  mounted: function mounted() {
    // this.createCanvas()
    // this.getEmojiList()
  },
  created: function created() {},
  methods: {
    commentFocus: function commentFocus(e) {
      this.$emit('commentFocus');
    },
    openEmoji: function openEmoji() {
      this.$emit('openEmoji', true); //, this.emojiList
    },
    openShare: function openShare() {
      this.$emit('openShare', true); //, this.emojiList
    },
    openDanmu: function openDanmu() {
      this.danmuOpen = !this.danmuOpen;
      this.$emit('openDanmu', this.danmuOpen);
    },
    createCanvas: function createCanvas() {
      // 飘心
      var _this = this;
      var ctx = document.getElementById("cvs").getContext("2d");
      ctx.canvas.width = _this.width, ctx.canvas.height = _this.height, function loop() {
        ctx.clearRect(0, 0, _this.width, _this.height);
        _this.heartList.forEach(function (item) {
          item && item.move(ctx);
        });
        requestAnimationFrame(loop);
      }();
    },
    likeHeart: function likeHeart() {
      this.heartList.push(this.createHeart());
      this.$emit('addTotalFav');
    },
    getRandomDis: function getRandomDis() {
      if (Math.random() > 0.5) {
        return -(Math.random() * 43);
      } else {
        return +(Math.random() * 43);
      }
    },
    createHeart: function createHeart() {
      this.heartCount++;
      var positionArray = [{
        x: 100,
        y: 400,
        endX: 100,
        endY: 100
      }];
      var img = new Image();
      // img.src = "../../static/img/" + Math.ceil(Math.random() * 2) + ".png";
      // img.src = `../../assets/images/live/emoji/${Math.ceil(Math.random() * 5)}.png`;
      img.src = require("@/assets/images/live/emoji/".concat(Math.ceil(Math.random() * 5), ".png"));
      var p1 = {
        x: 100 + this.getRandomDis(),
        y: 300 + this.getRandomDis()
      };
      var p2 = {
        x: 100 + this.getRandomDis(),
        y: 200 + this.getRandomDis()
      };
      return new LikeHeart({
        id: this.heartCount,
        x: positionArray[0].x,
        y: positionArray[0].y,
        endX: positionArray[0].endX,
        endY: positionArray[0].endY,
        onFadeOut: this.removeItem,
        noAngel: true,
        //决定是否从小到大
        // noScale: true,//决定是否左右摆动
        width: 28,
        //决定心的大小
        height: 28,
        image: img,
        bezierPoint: {
          p0: {
            x: positionArray[0].x,
            y: positionArray[0].y
          },
          p1: p1,
          p2: p2,
          p3: {
            x: positionArray[0].endX,
            y: positionArray[0].endY
          }
        }
      });
    },
    removeItem: function removeItem(item) {
      var array = [];
      for (var i = 0; i < this.heartList.length; i++) {
        if (this.heartList[i].id !== item.id) {
          array.push(this.heartList[i]);
        }
      }
      this.heartList = array;
    }
  }
};